<template>
  <button
    @click="download"
    :disabled="isFetching"
    class="btn btn-sm btn-outline-info">
    <slot></slot>
    <div v-if="isFetching" class="spinner-border small-spinner text-info" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </button>
</template>

<script>
import auth from "../../services/auth";
import { notify } from '../../services/notify';
import _ from 'lodash';

export default {
  name: "DownloadButton",
  props: {
    url: String,
    fileName: {
      type: String,
      default: 'certificate.pdf'
    }
  },
  data() {
    return {
      isFetching: false,
    };
  },
  methods: {
    download: _.debounce(function() {
      this.isFetching = true;
      fetch(this.url,
        {
          headers: {
            'Authorization': `Bearer ${auth.getAccessToken()}`,
            'Accept': 'application/pdf',
          }
        })
        .then(response => {
          if (response.ok) return response.blob();
          throw new Error(response.statusText);
        })
        .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          a.download = this.fileName;

          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(error => {
          notify().error(`Failed to fetch certificate.<br>${error}`);
        })
        .finally(() => {
          this.isFetching = false;
        });
    }, 10000, { leading: true, trailing: false }),
  }
};
</script>

<style>

</style>
